<script>

/**
 * Automodal 
 * 
 * Version 1.8
 * Ajutes menores generales. 
 * 
 * Version 1.7
 * Soporte para args,
 * 
 * Version 1.6
 * Agregado el concepto de archetypeUsuariosclientebinariosCFG, para administración de dependencias:
 *   Usuariosclientebinarios => Usuariosclientebinarios_hijo
 * 
 * Version 1.5
 * Remoción de DIV sobrante.
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import {extractForm} from '@/utils'
import md5 from 'js-md5'

import {archetype, archetypeUsuariosclientebinariosCFG, automodalHandler} from './archetype'

export default {
    name: 'UsuariosclientebinariosAutomodal',
    props: {
        conceptId: {
            type: [String, Number],
        },
        args: {
            type: Object,
            default: () => {return {}}
        }
    },

    data: () => {
        return {
            form: extractForm(archetype),
            file: null,
            asides: {
                // administradores: [],
                // distribuidores: [],
            }
        }
    },
    computed: {
        formArchetypeMD5(){
			return md5(JSON.stringify(this.cArchetype))
		},
        cArchetype(){
            let updated = [];
            _.forEach(archetype(), itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(this.handleItem(itemsRow));
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        archetypeUsuariosclientebinariosCFG,
        storedDone(response){
            console.log('response', response)
        },
        beforeStore(form){
            console.log('beforeStore', form)
            if(this.args.usuarioId){
                form.id_usuario_fk = this.args.usuarioId;
            }
            return form;
        },
        handleItem(item) {
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if (_.isObjectLike(item)) {
                switch (item.key) {
                    case 'url':
                        item.readonly = !!this.conceptId;
                        break;
                    default:
                        break;
                }
            }
            return item;
        },
        getHandler() {
            return automodalHandler((this.conceptId || this.form.id))
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (asides) 
                _.forEach(asides, (aside, asideKey) => {
                    this.asides[asideKey] = aside;
                })
        },
        onDisplay() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form" ref="automodal" 
        :size="form.id ? 'md': 'lg'"
        :label="form.id ? 'Actualizar archivo' : 'Nuevo archivo'" 
        :form-id="form.id" 
        :form-archetype="cArchetype" 
        :handler="getHandler()"  
        :allow-aside="!parseInt(form.id) && false" 
        :allow-delete="true"
        :form-key="formArchetypeMD5"
        :beforeStore="beforeStore"
        :args="args"
        :keep-on-success="false"
        @successStoring="storedDone"
        @refresh="refresh" 
        @defined="checkAsides" 
        @display="onDisplay" 
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="7">
            <b-tabs class="mb-4">
                <b-tab title="Alta de archivo" active>
                    <!-- 
                    <associationsmembers-quicktable :args="{ 
                        associationsId: form.id, 
                        passions: form.AssociationsCfg
                    }"/>
                    -->
                </b-tab>
            </b-tabs>
        </b-col>
        <b-col slot="bottom">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>